import * as Sentry from '@sentry/react';

/**
 * Our backend performs validations
 * on most endpoints and returns an annoying
 * data structure of validation errors to parse.
 * This function should in theory return
 * appropriate backend error messages 
 * for HTTP codes 400 - 500
 *
 * We likely will never see the fallback message,
 * unless backend sends a super whack data structure we
 * have not seen before
 */
export const getApiErrorMessage = (errorResponse: any, fallbackMessage: string) => {
  if (typeof errorResponse === 'string') {
    return errorResponse;
  } else if (errorResponse?.errors) {
    let errorMessages: string[] = [];
    Object.keys(errorResponse.errors).forEach((key: string) => {
      let message = errorResponse.errors[key];
      errorMessages.push(message);
    });
    return errorMessages.join();
  } else if (errorResponse.message) {
    return errorResponse.message;
  } else {
    console.log('Unknown error encountered');
    const exception = new Error("Unknown error encountered: " + String(errorResponse));
    Sentry.captureException(exception);
    return fallbackMessage;
  }
}
